import React, { Component } from "react";
import { getDateAsMonthYear } from "../helpers/helpers";

class LightboxVideo extends Component {
  constructor(props) {
    super(props);

    this.video = this.props.info;

    this.videoRef = React.createRef();
    this.playVideo = this.playVideo.bind(this);
    this.pauseVideo = this.pauseVideo.bind(this);
  }

  componentDidMount() {
    if (this.props.current) {
      this.playVideo();
    } else {
      this.pauseVideo();
    }
  }

  componentDidUpdate() {
    if (this.props.current) {
      this.playVideo();
    } else {
      this.pauseVideo();
    }
  }

  playVideo() {
    this.videoRef.current.play();
  }

  pauseVideo() {
    this.videoRef.current.pause();
  }

  // Get the caption, which includes the date
  getCaption() {
    return "Video from " + getDateAsMonthYear(this.video.mediaDate);
  }

  render() {
    return (
      <div className="lightbox__item">
        <video controls className="" type="video/mp4" ref={this.videoRef}>
          <source src={this.video.url} />
        </video>

        <div className="lightbox__info">
          <p className="lightbox__caption">{this.getCaption()}</p>
          {this.video.captionForSupporter ? (
            <p className="lightbox__description">
              {this.video.captionForSupporter}
            </p>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}

export default LightboxVideo;
